import { render, staticRenderFns } from "./InstanceEditTenants.vue?vue&type=template&id=086a3fa4&scoped=true&"
import script from "./InstanceEditTenants.vue?vue&type=script&lang=js&"
export * from "./InstanceEditTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a3fa4",
  null
  
)

export default component.exports